import { render, staticRenderFns } from "./textarea-el-input.vue?vue&type=template&id=25c2e3cd&scoped=true&"
import script from "./textarea-el-input.vue?vue&type=script&lang=js&"
export * from "./textarea-el-input.vue?vue&type=script&lang=js&"
import style0 from "./textarea-el-input.vue?vue&type=style&index=0&id=25c2e3cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c2e3cd",
  null
  
)

export default component.exports